import { useTicketFilters } from '@/hooks/useTicketFilters';

import { useAuth } from '@/providers/AuthProvider';

import { UserRole } from '@packages/database/types';
import { cn } from '@/lib/utils';
import { QUICK_FILTERS } from '../config/ticketQuickFilters';

const isFilterActive = (
  filterParams: Record<string, any>,
  currentFilters: Record<string, string>,
): boolean => {
  const entries = Object.entries(filterParams);
  if (entries.length === 0) {
    return !Object.values(currentFilters).some((v) => v && v !== 'all');
  }
  return entries.every(
    ([k, v]) => currentFilters[k as keyof typeof currentFilters] === v,
  );
};

export const TicketQuickFilters = () => {
  const { user } = useAuth();
  const { filters, setFilters, clearFilters } = useTicketFilters();
  //   const { counts, isLoadingCounts } = useTicketCounts();

  const role = user?.role as UserRole;
  const quickFilters = QUICK_FILTERS[role] ?? [];

  if (quickFilters.length === 0) return null;

  const handleClick = (qf: (typeof quickFilters)[number]) => {
    if (Object.keys(qf.params).length === 0) {
      clearFilters();
      return;
    }
    setFilters({
      q: '',
      status: 'all',
      priority: 'all',
      projectId: '',
      crewId: '',
      createdOn: '',
      category: undefined,
      assignmentStatus: '',
      assignedTo: '',
      page: 1,
      limit: 20,
      ...qf.params,
    });
  };

  return (
    <div className="flex items-center gap-1.5 flex-wrap">
      {quickFilters.map((qf) => {
        const active = isFilterActive(qf.params, filters as any);
        // const count = qf.countKey ? counts[qf.countKey] : undefined;

        return (
          <button
            key={qf.id}
            type="button"
            onClick={() => handleClick(qf)}
            className={cn(
              'inline-flex items-center gap-1.5 h-7 px-3 rounded-full text-xs font-medium',
              'border transition-all duration-150 cursor-pointer select-none',
              'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
              !active && [
                'border-border bg-background text-muted-foreground',
                'hover:bg-accent hover:text-accent-foreground hover:border-border/80',
              ],
              active && [
                'border-foreground/20 bg-foreground text-background',
                'dark:border-foreground/20 dark:bg-foreground dark:text-background',
                'shadow-sm',
              ],
            )}
          >
            {qf.label}

            {/* {!isLoadingCounts && count !== undefined && (
              <span
                className={cn(
                  'inline-flex items-center justify-center tabular-nums',
                  'min-w-[18px] h-[18px] px-1 rounded-full text-[10px] font-semibold',
                  active
                    ? 'bg-background/20 text-background'
                    : 'bg-muted text-muted-foreground',
                )}
              >
                {count}
              </span>
            )}

            {isLoadingCounts && qf.countKey && (
              <span className="inline-block w-5 h-3 rounded-full bg-muted animate-pulse" />
            )} */}
          </button>
        );
      })}
    </div>
  );
};
